import { render } from "./Dizziness_checklist.vue?vue&type=template&id=4e5e3353"
import script from "./Dizziness_checklist.vue?vue&type=script&lang=js"
export * from "./Dizziness_checklist.vue?vue&type=script&lang=js"

import exportComponent from "/app/websites/dizztinct/dizztinct-patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__